export default "__VITE_ASSET__BeSo15AZ__"